import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import type React from 'react';
import { useThemeMode } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { themeMode, toggleThemeMode } = useThemeMode();
  const theme = useTheme();

  return (
    <Tooltip
      title={themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        },
        tooltip: {
          sx: {
            backgroundColor: theme.palette.greyContrast,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            fontSize: '1rem',
            borderRadius: 1.5,
            boxShadow: 3,
            px: 2,
            py: 1,
          },
        },
      }}
    >
      <IconButton
        onClick={toggleThemeMode}
        color="inherit"
        aria-label="toggle theme"
        edge="end"
        sx={{
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.greyContrast
              : theme.palette.bidlogiq.charcoal,
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        {themeMode === 'dark' ? (
          <Brightness7Icon sx={{ fontSize: '2rem' }} />
        ) : (
          <Brightness4Icon sx={{ fontSize: '2rem' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
